import { IAddressCard } from '@seb/web-design-system/checkout';
import { Address } from '@spartacus/core';
import { containsExpressCheckout } from '../utils/address.utils';

export function toAddressCard(address: Address): IAddressCard {
  if (!address) {
    return undefined;
  }
  return {
    addressName: address?.addressName && !containsExpressCheckout(address.addressName) ? address.addressName : '',
    firstname: address.firstName ? address.firstName : '',
    lastname: address.lastName ? address.lastName : '',
    address: `${address.streetNumber ? address.streetNumber : ''} ${address.streetName ? address.streetName : ''}`,
    postalCode: address.postalCode ? address.postalCode : '',
    city: address.town ? address.town : '',
    pickup: address.pickupID !== undefined
  };
}
